import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components/macro';
import { useSelector } from 'react-redux';

import PleaseWait from 'components/PleaseWait';
import selectors from 'state/selectors';
import ModuleNotFound from 'components/ModuleNotFound';
import { Template } from 'models/response';

import Users from './Users/Users';
import Mapper from './Mapper/Mapper';
import Tables from './Tables/Tables';
import Companies from './Companies/Companies';
import RolesUserCompany from './RolesUserCompany';
import ActionTables from './ActionTables';
import Workflow from './Workflow';
import Vendor from './Vendor';
import Notification from './Notification';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 0;
  position: relative;
  height: calc(100vh - 170px);
  overflow: hidden;
  background-color: ${({ theme }) =>
    theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey2 : theme.colorPalette.white};
`;

const Routes = () => {
  const activeTemplateId = useSelector(selectors.configurator.selectActiveTemplateId);
  const templates = useSelector(selectors.configurator.selectTemplates);
  const { path } = useRouteMatch();

  const renderConfigModuleByTemplate = (template: Template) => {
    switch (template.description) {
      case 'USERS': {
        return Users;
      }
      case 'MAPPER': {
        return Mapper;
      }
      case 'TABLES': {
        return Tables;
      }
      case 'COMPANIES': {
        return Companies;
      }
      case 'ROLES': {
        return RolesUserCompany;
      }
      case 'ACTIONS': {
        return ActionTables;
      }
      case 'WORKFLOW': {
        return Workflow;
      }
      case 'VMD': {
        return Vendor;
      }
      case 'NOTIFICATIONS': {
        return Notification;
      }
      default:
        return ModuleNotFound;
    }
  };

  return (
    <Wrapper>
      <Switch>
        {templates?.map((template, i) => {
          // HOC outside render
          // https://reactjs.org/docs/higher-order-components.html
          const ConfigModule = renderConfigModuleByTemplate(template);
          return (
            <Route
              render={() => <ConfigModule />}
              key={`${template.idTemplate}-${i}`}
              path={`${path}/${template.description}`}
            />
          );
        })}
        <Route path="*" component={activeTemplateId ? ModuleNotFound : PleaseWait} />
      </Switch>
    </Wrapper>
  );
};

export default Routes;
